import { Appointment, AppointmentID } from "./Appointment";
import { CarID } from "./Car";
import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { Intervention, InterventionID } from "./Intervention";
import { QuestionResult, QuestionResultID } from "./QuestionResult";
import { RecallID } from "./Recall";
import { User, UserID } from "./User";

export type PinID = number;

export type PinNoteAttachmentID = number;

export enum PIN_TYPES {
  Remarks = 1,
  Warranty = 2,
  Recall = 3
}

export enum WARRANTY_TYPES {
  NotSet = 0,
  FirstFromNotSet = 1,
  Factory = 1,
  Leniency = 2,
  BodyPaint = 3,
  OnRepair = 4,
  Occasion = 5,
  Service = 6
}

export enum PIN_STATUSES {
  NotSet = 0,
  Deleted = 1,
  Support = 2,
  ApprovalPending = 3,
  MoreInfo = 4,
  Approved = 5,
  Declined = 6,
  ToClaim = 7,
  Claimed = 8,
  Billed = 9,
  Request = 10,
  TechnicalInfo = 11
}

export enum PIN_ORDER_STATUSES {
  SameDay = 1,
  ToOrder = 2,
  NextDay = 3,
  BackOrder = 4,
  PartsArrived = 5
}

export interface Pin {
  created_on: string;
  updated_on: string;
  id: PinID;
  question_result_id: QuestionResultID | null; // QuestionResult Identifier if this pin is linked to one
  intervention_id: InterventionID | null; // Intervention Identifier if this pin is linked to one
  pin_type_id: PIN_TYPES; // Type of the pin
  warranty_type_id: WARRANTY_TYPES; // Warranty classification for the pin
  pin_status_id: PIN_STATUSES; // Current status of the pin
  claim_nr: string; // Warranty or insurance claim number
  ref_nr: string; // Reference number (internal or external)
  support_nr: string; // Support ticket or case number
  order_status: PIN_ORDER_STATUSES | null; // Order processing status of the pin
  note: string; // Free-form notes or comments
  visible_important_items: boolean; // Whether important items are visible to user
  keep_parts: boolean; // Whether to retain parts after service
  info: boolean; // Information-only flag (non-actionable)
  mechanic_fixed: boolean; // Indicates if mechanic has resolved the issue
  is_dms: boolean; // Flag for pins originating from DMS (Dealer Management System)
  user_id: UserID; // ID of the user who created or owns the pin
  appointment_id: AppointmentID; // Linked appointment for the pin
  dealer_location_id: DealerLocationID; // Dealer Location associated with the pin
  car_id: CarID; // Vehicle related to the pin
  manufacturer_id: UserID | null; // Manufacturer user associated with the pin
  recalls_id: RecallID; // Associated recall identifier, if this pin is linked to one
  pon_recall_id: string; // Associated PON recall identifier, if this pin is linked to one
  rdw_recall_id: string; // Associated RDW recall identifier, if this pin is linked to one
  user?: User;
  appointment?: Appointment;
  intervention?: Intervention;
  question_result?: QuestionResult;
  manufacturer?: User;
  reg_number?: string;
  dealer_id?: DealerID;
  note_attachments?: string[];
  dealer_name?: string;
  location_name?: string;
  status_changed?: boolean;
}

export interface PinType {
  id: PIN_TYPES;
  name: string;
}

export interface WarrantyType {
  id: WARRANTY_TYPES;
  name: string;
}

export interface PinStatus {
  id: PIN_STATUSES;
  name: string;
}

export interface PinOrderStatus {
  id: PIN_ORDER_STATUSES;
  name: string;
}

export interface PinNoteAttachment {
  created_on: string;
  id: PinNoteAttachmentID; // Claire PinNoteAttachment Identifier
  url: string; // Url of the PinNoteAttachment
  pin_id: PinID; // Identifier of the Pin row where the note was added
}
